@if ((cylinderMainLock$ | async)) {
  <icc-select-box
    [title]="'DOOR|Rodzaj wkładki zamka głównego' | translate"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [imageUrl]="(cylinderMainLockBoxSelect$ | async)?.imagePath"
    [buttonText2]="((isKeyAvailableForMainLock || cylindersBoxSelect?.cylinders?.color) && 'INTERFACE|Opcje' | translate)"
    (select)="changeCylinderToMainLock()"
    (select2)="changeCylinderToMainLockOptions()"
    [descriptionTemplate]="cylindersMainLockBoxTemplate"
    [descriptionContext]="cylindersBoxSelect"
    [disabledButton1]="isCylinderMainLockButtonDisabled()"
    [disabledButton2]="isCylinderMainLockButton2Disabled()"
  ></icc-select-box>
}
@if ((cylinderAdditionalLock$ | async)) {
  <icc-select-box
    [title]="'DOOR|Rodzaj wkładki zamka dodatkowego' | translate"
    [imageUrl]="(cylinderAdditionalLockBoxSelect$ | async)?.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="((isKeyAvailableForAdditionalLock || !isCylinderAdditionalLockButton2Disabled()) && 'INTERFACE|Opcje' | translate)"
    (select)="changeCylinderToAdditionalLock()"
    (select2)="changeCylinderToAdditionalLockOptions()"
    [descriptionTemplate]="cylindersAdditionalLockBoxTemplate"
    [descriptionContext]="cylindersBoxSelect"
    [disabledButton1]="isCylinderAdditionalLockButtonDisabled()"
    [disabledButton2]="isCylinderAdditionalLockButton2Disabled()"
  ></icc-select-box>
}
<!--
/*
Hidden until client describes how the cylinder system is supposed to work.
*/
<icc-select-box
  *ngIf="(cylinderSystem$ | async)"
  [title]="'DOOR|System wkładek' | translate"
  [description]="(cylinderSystem$ | async)?.name"
  [imageUrl]="'/files/windowaccessorysystem/' + ((cylinderSystem$ | async)?.image || '')"
  [disabledButton1]="isCylinderSystemButtonDisabled()"
></icc-select-box> -->
@if ((cylinderMainLock$ | async)?.electronic_door_lock) {
  <icc-select-box
    [title]="'DOOR|Typ elektronicznej wkładki' | translate"
    [imageUrl]="electronicLock.imagePath"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [buttonText2]="'INTERFACE|Opcje' | translate"
    (select)="changeElectronicLock()"
    (select2)="changeElectronicLockOptions()"
    [disabledButton1]="isElectronickLockButtonDisabled()"
    [disabledButton2]="hasElectronicLockColors()"
    [descriptionTemplate]="electronicLockBoxTemplate"
    [descriptionContext]="electronicLock"
  ></icc-select-box>
}

<ng-template #cylindersMainLockBoxTemplate let-cylinders="cylinders">
  @if (cylinders?.mainLockName) {
    <p> <b>{{ 'DOOR|Typ' | translate }}</b> {{cylinders.mainLockName}}</p>
  }
  @if (cylinders?.mainLockColor) {
    <p>
        <b>{{ 'COLOR|Kolor:' | translate }}</b> {{cylinders?.mainLockColor}}
    </p>
  }
  <p ng-bind-html="description"></p>
</ng-template>

<ng-template #cylindersAdditionalLockBoxTemplate let-cylinders="cylinders">
    @if (cylinders?.additionalLockName) {
      <p> <b>{{ 'DOOR|Typ' | translate }}</b> {{cylinders.additionalLockName}}</p>
    }
    @if (cylinders?.additionalLockColor) {
      <p>
          <b>{{ 'COLOR|Kolor:' | translate }}</b> {{cylinders?.additionalLockColor}}
      </p>
    }
    <p ng-bind-html="description"></p>
</ng-template>

<ng-template #electronicLockBoxTemplate>
  @if (electronicLock?.electronicLockName) {
    <p>
      <b>{{ 'DOOR|Typ' | translate }}</b> {{ electronicLock?.electronicLockName }}
    </p>
  }
  @if (electronicLock?.electronicLockColor) {
    <p>
      <b>{{ 'DOOR|Kolor: ' | translate }}</b> {{ electronicLock?.electronicLockColor }}
    </p>
  }
  <p ng-bind-html="description"></p>
</ng-template>
